module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m8-478f3a042ea472afe1a2e6b95b81e351.png";